import * as consts from "../consts";
import axios from "axios";

export function handleError(exception, message, dispatch) {
  if (process.env.NODE_ENV === "development") {
    console.log("TB-CARDBUILDER:", exception);
  }
  if (message && dispatch) {
    addAlert(
      {
        message: message,
        type: consts.ALERT_TYPE_ERROR,
      },
      dispatch
    );
  }
}

function handleSuccess(response, message, dispatch) {
  if (process.env.NODE_ENV === "development") {
    console.log("TB-CARDBUILDER:", response);
  }
  if (message && dispatch) {
    addAlert(
      {
        message: message,
        type: consts.ALERT_TYPE_SUCCESS,
      },
      dispatch
    );
  }
}

function getHTTPHeaders(getAccessTokenSilently) {
  return new Promise((resolve) => {
    if (getAccessTokenSilently) {
      getAccessTokenSilently()
        .then((token) => {
          let options = token
            ? { headers: { Authorization: `Bearer ${token}` } }
            : {};
          resolve(options);
        })
        .catch(() => {
          resolve({});
        });
    } else {
      resolve({});
    }
  });
}

export function addAlert(alert, dispatch) {
  return new Promise((resolve) => {
    dispatch({
      type: consts.ACTION_ADD_ALERT,
      payload: alert,
    });
    resolve();
  });
}

export function dismissAlert(dispatch) {
  return new Promise((resolve) => {
    dispatch({
      type: consts.ACTION_DISMISS_ALERT,
    });
    resolve();
  });
}

export function setBusy(busy, dispatch) {
  return new Promise((resolve) => {
    dispatch({
      type: consts.ACTION_SET_BUSY,
      payload: busy,
    });
    resolve();
  });
}

export function updateCart(cart, dispatch) {
  return new Promise((resolve) => {
    dispatch({
      type: consts.ACTION_SET_CART,
      payload: cart,
    });
    handleSuccess(null, `Successfully updated cart`, dispatch);
    resolve();
  });
}

export function getProfile(getAccessTokenSilently, dispatch) {
  return new Promise((resolve, reject) => {
    getHTTPHeaders(getAccessTokenSilently).then((options) => {
      axios
        .get(`${consts.SERVICE_URL}/Profile`, options)
        .then((response) => {
          let profile = response.data;
          dispatch({
            type: consts.ACTION_INITIALIZE_PROFILE,
            payload: profile,
          });
          resolve(profile);
        })
        .catch((exception) => {
          handleError(exception, `Unable to retrieve profile`, dispatch);
          reject(exception);
        });
    });
  });
}

export function getCartQuote(
  cart,
  shippingMethods,
  getAccessTokenSilently,
  dispatch
) {
  return new Promise((resolve, reject) => {
    getHTTPHeaders(getAccessTokenSilently).then((options) => {
      axios
        .post(
          `${consts.SERVICE_URL}/Purchase/cartdetail`,
          { cartItems: cart },
          options
        )
        .then((response) => {
          let cartQuote = response.data;
          let updatedCart = [...cart];
          cartQuote.map((item) => {
            let index = updatedCart.findIndex((cartItem) => {
              return cartItem.cartItemID == item.cartItemID;
            });
            if (index > -1) {
              updatedCart[index].cardDetails.map(
                (cardDetail, cardDetailIndex) => {
                  cardDetail.shipping.shipMethods =
                    item.cardDetails[cardDetailIndex].shipping.shipMethods;
                  cardDetail.cardFee =
                    item.cardDetails[cardDetailIndex].cardFee;

                  let selectedShippingMethod = null;
                  if (cardDetail.shipping && cardDetail.shipping.shipMethods) {
                    selectedShippingMethod =
                      cardDetail.shipping.shipMethods.find((x) => {
                        return x.id == cardDetail.shipping.method;
                      });
                    if (!selectedShippingMethod) {
                      cardDetail.shipping.method =
                        cardDetail.shipping.shipMethods[0].id;
                    }
                  }
                }
              );
            }
          });
          resolve(updatedCart);
        })
        .catch((exception) => {
          handleError(exception, `Unable to retrieve quote`, dispatch);
          reject(exception);
        });
    });
  });
}

export function setSupportPercent(supportPercent, supportTotal, dispatch) {
  return new Promise((resolve) => {
    dispatch({
      type: consts.ACTION_SET_SUPPORT_PERCENT,
      payload: {
        supportPercent: supportPercent,
        supportTotal: Math.round(parseFloat(supportTotal) * 100) / 100,
      },
    });
    resolve();
  });
}

export function setSupportTotal(supportTotal, dispatch) {
  return new Promise((resolve) => {
    dispatch({
      type: consts.ACTION_SET_SUPPORT_TOTAL,
      payload: Math.round(parseFloat(supportTotal) * 100) / 100,
    });
    resolve();
  });
}

export function setBilling(billing, dispatch) {
  return new Promise((resolve) => {
    dispatch({
      type: consts.ACTION_SET_BILLING,
      payload: billing,
    });
    resolve();
  });
}

export function setOptIn(optIn, dispatch) {
  return new Promise((resolve) => {
    dispatch({
      type: consts.ACTION_SET_OPT_IN,
      payload: optIn,
    });
    resolve();
  });
}

export function setBusinessUse(businessUse, dispatch) {
  return new Promise((resolve) => {
    dispatch({
      type: consts.ACTION_SET_BUSINESS_USE,
      payload: businessUse,
    });
    resolve();
  });
}

export function getShippingMethods(dispatch) {
  return new Promise((resolve, reject) => {
    axios
      .get(`${consts.SERVICE_URL}/Purchase/shippingrates`, {})
      .then((response) => {
        let shippingMethods = response.data;
        shippingMethods = shippingMethods.sort((a, b) => {
          return a.sortOrder < b.sortOrder ? 1 : 0;
        });
        dispatch({
          type: consts.ACTION_INITIALIZE_SHIPPING_METHODS,
          payload: shippingMethods,
        });
        resolve(shippingMethods);
      })
      .catch((exception) => {
        handleError(exception, `Unable to retrieve shipping methods`, dispatch);
        reject(exception);
      });
  });
}

export function processCart(
  transactionID,
  optIn,
  businessUse,
  cart,
  billing,
  displayedTotal,
  supportTotal,
  creditCardFee,
  quoteid,
  campaignID,
  orderAdjustments,
  getAccessTokenSilently,
  dispatch
) {
  return new Promise((resolve, reject) => {
    getHTTPHeaders(getAccessTokenSilently).then((options) => {
      let formData = new FormData();
      let cartItems = [];
      let files = [];
      let storedCouponCode = sessionStorage.getItem(consts.STORAGE_COUPON_CODE);
      cart.map((cartItem) => {
        let cardDetails = [];
        cartItem.cardDetails.map((cardDetail) => {
          cardDetails.push({
            cardFee: cardDetail.cardFee,
            to: cardDetail.to,
            from: cardDetail.from,
            email: cardDetail.email,
            deliveryDate: cardDetail.deliveryDate,
            message: cardDetail.message,
            shipping: {
              name: cardDetail.shipping.name,
              company: cardDetail.shipping.company,
              address: cardDetail.shipping.address,
              city: cardDetail.shipping.city,
              state: cardDetail.shipping.state,
              zip: cardDetail.shipping.zip,
              method: cardDetail.shipping.method,
            },
          });
        });
        cartItems.push({
          mailOption: cartItem.mailOption,
          emailOption: cartItem.emailOption,
          cardType: cartItem.cardType,
          cardValue: cartItem.cardValue,
          cartItemID: cartItem.cartItemID,
          cardImage: cartItem.cartItemID,
          cardDetails: cardDetails,
        });
        files.push({ url: cartItem.cardImage, name: cartItem.cartItemID });
      });
      let promises = [];
      files.map((file) => {
        promises.push(
          new Promise((resolve) => {
            if (file.url.startsWith("https")) {
              let blobRequest = new XMLHttpRequest();
              blobRequest.open("GET", file.url, true);
              blobRequest.responseType = "blob";
              blobRequest.onload = function () {
                if (blobRequest.status == 200) {
                  resolve({ blob: blobRequest.response, name: file.name });
                }
              };
              blobRequest.send();
            } else {
              let blobArray = file.url.split(",");
              let mime = blobArray[0].match(/:(.*?);/)[1];
              let base64String = atob(blobArray[1]);
              let base64StringLength = base64String.length;
              let uInt8Array = new Uint8Array(base64StringLength);
              while (base64StringLength--) {
                uInt8Array[base64StringLength] =
                  base64String.charCodeAt(base64StringLength);
              }
              resolve({
                blob: new Blob([uInt8Array], { type: mime }),
                name: file.name,
              });
            }
          })
        );
      });
      Promise.all(promises).then((values) => {
        values.map((value) => {
          formData.append("files", value.blob, value.name);
        });
        formData.append("transactionID", transactionID);
        formData.append("optIn", optIn);
        formData.append("businessUse", businessUse);
        formData.append("cartItems", JSON.stringify(cartItems));
        formData.append("billing", JSON.stringify(billing));
        formData.append("displayedTotal", displayedTotal);
        formData.append("campaignID", campaignID);
        formData.append("orderAdjustments", JSON.stringify(orderAdjustments));
        formData.append("donationAmount", supportTotal);
        formData.append("creditCardFee", creditCardFee);
        formData.append("couponCode", storedCouponCode);
        options = {
          ...options,
          headers: {
            ...options.headers,
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
          },
        };
        axios
          .post(`${consts.SERVICE_URL}/Purchase/ProcessCart`, formData, options)
          .then((response) => {
            if (quoteid) {
              axios
                .get(
                  `${consts.SERVICE_URL}/Quote/${quoteid}/${response.data.orderID}/${response.data.transactionID}/CCPaid`,
                  {}
                )
                .then(() => {
                  dispatch({
                    type: consts.ACTION_COMPLETE_PURCHASE,
                    payload: {
                      response: response.data,
                      cartItems: cartItems,
                      billing: billing,
                      displayedTotal: displayedTotal,
                      donationAmount: supportTotal,
                    },
                  });
                  resolve(response.data);
                });
            } else {
              dispatch({
                type: consts.ACTION_COMPLETE_PURCHASE,
                payload: {
                  response: response.data,
                  cartItems: cartItems,
                  billing: billing,
                  displayedTotal: displayedTotal,
                  donationAmount: supportTotal,
                },
              });
              resolve(response.data);
            }
          })
          .catch((exception) => {
            handleError(exception, `Unable to process payment`, dispatch);
            reject(exception);
          });
      });
    });
  });
}

export function saveCart(email, getAccessTokenSilently, dispatch) {
  return new Promise((resolve, reject) => {
    getHTTPHeaders(getAccessTokenSilently).then((options) => {
      let cart = localStorage.getItem(consts.STORAGE_CART);
      axios
        .post(
          `${consts.SERVICE_URL}/Cart`,
          { cart: cart, email: email },
          options
        )
        .then((response) => {
          let cartCode = response.data;
          resolve(cartCode);
        })
        .catch((exception) => {
          handleError(exception, `Unable to save cart`, dispatch);
          reject(exception);
        });
    });
  });
}

export function getSavedQuote(quoteid) {
  return new Promise((resolve, reject) => {
    if (quoteid) {
      axios
        .get(`${consts.SERVICE_URL}/Quote/${quoteid}`, {})
        .then((response) => {
          axios.get(`${consts.SERVICE_URL}/Quote/${quoteid}/Viewed`, {});
          let cart = response.data;
          resolve(cart);
        })
        .catch((exception) => {
          resolve(null);
        });
    } else {
      resolve(null);
    }
  });
}

export function getQuoteDetails(quoteid) {
  return new Promise((resolve, reject) => {
    if (quoteid) {
      axios
        .get(`${consts.SERVICE_URL}/Quote/${quoteid}/details`, {})
        .then((response) => {
          let quoteDetails = response.data;
          resolve(quoteDetails);
        })
        .catch((exception) => {
          resolve(null);
        });
    } else {
      resolve(null);
    }
  });
}

export function setQuoteDetails(quoteDetails, dispatch) {
  return new Promise((resolve) => {
    dispatch({
      type: consts.ACTION_SET_QUOTE_DETAILS,
      payload: quoteDetails,
    });
    resolve();
  });
}
